/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon32Regular = forwardRef('CertRosetteAltIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 2C10.477 2 6 6.477 6 12a9.97 9.97 0 0 0 3 7.141V29.35c0 1.397 1.558 2.231 2.72 1.456L16 27.952l4.28 2.853c1.162.775 2.72-.059 2.72-1.456V19.14A9.97 9.97 0 0 0 26 12c0-5.523-4.477-10-10-10ZM8 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm13 8.662A9.955 9.955 0 0 1 16 22a9.955 9.955 0 0 1-5-1.338v8.22l4.03-2.687a1.75 1.75 0 0 1 1.94 0L21 28.881v-8.219Z" })));
});
